// 搜索 - 平台下拉框
export const platformList = [
  {
    platform: 'web',
    platformName: 'web',
  },
  {
    platform: 'h5',
    platformName: 'h5',
  },
]

// 搜索 - 操作结果下拉框
export const statusList = [
  {
    statusId: 0,
    status: '失败',
  },
  {
    statusId: 1,
    status: '成功',
  },
]
